import { FormEvent, useContext, useEffect, useRef, useState } from "react"
import { EventContext, EventContextType } from "../provider/EventProvider";
import { getSearchMessage } from "../../Helpers/utils";

export type EventsSearchBoxModel = {
  resultMessage: string,
  noResultMessage: string
}

export default function EventsSearchBox({ resultMessage, noResultMessage }: EventsSearchBoxModel) {
  const [message, setMessage] = useState<string>('');
  
  const { totalRecords, events, filters, termSetter } = useContext(EventContext) as EventContextType;
  const searchBox = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (events && events.length > 0 && filters.searchTerm.length > 0) {
      setMessage(getSearchMessage(filters.searchTerm, totalRecords, noResultMessage, resultMessage));
    } else {
      setMessage('');
    }
  }, [events])

  useEffect(() => {
    if (searchBox.current) {
      searchBox.current.value = filters.searchTerm;
      searchBox.current.focus();
    }
  }, [filters.searchTerm])

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    termSetter(searchBox.current?.value ?? '');
  };

  return (
    <div className="search-box">
      <form className="searchbox-form" onSubmit={onFormSubmit}>
        <input type="text" className="form-control" placeholder="Search..." ref={searchBox} />
        <button type='submit'><span className="fa fa-search" aria-hidden="true"></span></button>
      </form>
      { (totalRecords === 0 || (totalRecords > 0 && filters.searchTerm.length > 0)) && 
        <div dangerouslySetInnerHTML={ { __html: message}} >
        </div>
      }
    </div>
  )
}